<script setup lang="ts">
import { compileScript } from '@vue/compiler-sfc'
import FilterSetting from './FilterSetting.vue'
import { useStationDataStore } from '~/stores/stations'
import { LayerPresets } from '~/types/map'

const stationStore = useStationDataStore()
const filterSettings = computed(() => stationStore.filterSettings)
const activeDatafilters = inject<string[]>('activeDatafilters')

function showSetting(key: string) {
  if (!activeDatafilters) return true
  return activeDatafilters.includes(key)
}
</script>
<template>
  <FilterSetting
    v-if="showSetting('station.electricityOrigin')"
    content-type="station"
    :setting="filterSettings.electricityOrigin"
    class="mt-2 mb-4"
  />
  <FilterSetting
    v-if="showSetting('station.stationCategories')"
    content-type="station"
    :setting="filterSettings.stationCategories"
    class="mt-2 mb-4"
  />
  <FilterSetting
    v-if="showSetting('station.fuelTypes')"
    content-type="station"
    :setting="filterSettings.fuelTypes"
    class="mt-2 mb-4"
  />
  <FilterSetting
    v-if="showSetting('station.stationType')"
    content-type="station"
    :setting="filterSettings.stationType"
    class="mt-2 mb-4"
  />
</template>
